
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.heroSlider()
            this.newsSlider()
            this.bfafSlider()
        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.newsSlider()
            this.bfafSlider()
        });
        
    }
    
    heroSlider(){
        new Swiper ('#hero--slider',{
            loop: true,
            effect :'fade',
            speed:3000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 4000
            }
        })
    }
    newsSlider(){
        const newsSlider = new Swiper('.l-hero__news--inner', {
            loop: true,
            speed: 2000,
            allowTouchMove :false,
            simulateTouch:false,
            navigation: {
                nextEl: '.l-hero__news--next',
                prevEl: '.l-hero__news--prev',
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction:false
            }
        })
    }
    bfafSlider(){
        const bfafSlider = new Swiper('.js-bfaf__slider', {
            loop: true,
            speed: 2000,
            allowTouchMove :true,
            simulateTouch:true,
            navigation: {
                nextEl: '.p-bfaf__news--next',
                prevEl: '.p-bfaf__news--prev',
            },
        })
    }
}